import React from 'react';
import styled from 'styled-components';
import ListConversationsModal from './ActionModals/ListConversationsModal';
import ManagePauseModal from './ActionModals/ManagePauseModal';
import ManageQueuesModal from './ActionModals/ManageQueuesModal';

const ActionsWrapper = styled.div``;

export const SupervisorPanelChatActions = React.memo((props) => {
  return (
    <ActionsWrapper>
      <ManageQueuesModal {...props} />
      <ManagePauseModal {...props} />
      <ListConversationsModal {...props} />
    </ActionsWrapper>
  );
});
